import React from 'react'
import { TabbedForm } from 'react-admin'
import { ServicesConfig } from 'services/api/entities/servicesconfig'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import { keys } from 'services/utils'
import { CustomFormProps } from 'types/common'
import BaseCfgTab from './FormTabs/BaseCfgTab'
import FoodServiceCfgTab from './FormTabs/FoodServiceCfgTab'
import GeneralCfgTab from './FormTabs/GeneralCfgTab'
import ProfessionalsCfgTab from './FormTabs/ProfessionalsCfgTab'

export type ServiceCfgFormProps = CustomFormProps

const ServicesConfigForm: React.FC<ServiceCfgFormProps> = (props) => {
  const record = useKRecordContext<ServicesConfig>()

  if (!record) return null
  const { id, generalService, professionalService, foodService, ...rest } =
    record
  return (
    <TabbedForm>
      <GeneralCfgTab {...props} />

      <FoodServiceCfgTab />
      {keys(rest).map((servName, idx) => (
        <BaseCfgTab {...props} servName={servName} key={idx} />
      ))}
      <ProfessionalsCfgTab {...props} />
    </TabbedForm>
  )
}

export default ServicesConfigForm
